import { useTranslation } from '@bcba/react-hooks';
import { useNavigate } from 'react-router-dom';
import { paths } from '../routes/paths';
import { ErrorPage as ComponentErrorPage } from '@agrotoken-tech/ui';
import { FC } from 'react';
import { ERROR_CODES, HttpStatus } from '@bcba/types';

type ErrorCode =
  | 'FORBIDDEN_RESOURCE'
  | 'RECORD_NOT_FOUND'
  | 'INTERNAL_SERVER_ERROR';

interface ErrorPageProps {
  errorCode?: ErrorCode;
  mainErrorMessage?: string;
  errorDescription?: string;
}

export const HTTP_ERROR_CODES: Record<ErrorCode, number> = {
  [ERROR_CODES.FORBIDDEN_RESOURCE]: HttpStatus.FORBIDDEN,
  [ERROR_CODES.RECORD_NOT_FOUND]: HttpStatus.NOT_FOUND,
  [ERROR_CODES.INTERNAL_SERVER_ERROR]: HttpStatus.INTERNAL_SERVER_ERROR,
};

export const ErrorPage: FC<ErrorPageProps> = ({
  errorCode = ERROR_CODES.RECORD_NOT_FOUND,
  mainErrorMessage,
  errorDescription,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || '';

  const errorMessage =
    mainErrorMessage ?? t(`errorPage.${errorCode}.mainErrorMessage`);
  const description =
    errorDescription ??
    t(`errorPage.${errorCode}.errorDescription`).replace(
      '{{emailContact}}',
      contactEmail,
    );

  const goToHome = () => {
    navigate(paths.home);
  };

  return (
    <ComponentErrorPage
      error={HTTP_ERROR_CODES[errorCode]}
      mainErrorMessage={errorMessage}
      errorDescription={description}
      primaryButtonLabel={t('errorPage.goBack')}
      onClickPrimaryButton={goToHome}
    />
  );
};

export default ErrorPage;
